<template>
  <div>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px">
      <v-card class="pb-2">
        <v-card-title>
          <span class="title">{{ $t('CART.CHOOSE_COUNTRY') }}</span>
          <v-spacer/>
          <tk-btn icon @click="$emit('input', !value)">
            <v-icon>fas fa-times</v-icon>
          </tk-btn>
        </v-card-title>

        <v-card-text>
          <tk-country-select v-model="shippingCountry" @change="onCountryChange" return-object/>

          <div v-if="loading" class="text-xs-center my-5">
            <v-progress-circular :size="50" color="black" indeterminate/>
          </div>
          <h3 v-else class="title text-xs-center py-3">{{ shippingCost }}</h3>
        </v-card-text>

        <v-card-actions v-if="cart">
          <v-spacer></v-spacer>
          <tk-btn
            v-if="cart.country && cart.country.is_delivery_available"
            color="primary"
            @click="addToCart"
          >{{ $t('ARTWORK.ADD_TO_CART') }}</tk-btn>
          <tk-btn
            v-else
            color="primary"
            @click="$emit('onOpenAskUs', cart.country)"
          >{{ $t('ARTWORK.ASK_ABOUT_SHIPPING')}}</tk-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ErrorHandler } from "@/utils/ErrorHandler";
const handler = new ErrorHandler();

export default {
  props: ["value", "artworkId"],

  components: {
    TkCountrySelect: () => import("@/components/core/TkCountrySelect"),
    TkAskUsDialog: () => import("@/components/core/TkAskUsDialog")
  },

  data() {
    return {
      loading: false,
      showAskUsDialog: false,
      cart: null,
      shippingCountry: null
    };
  },

  computed: {
    shippingCost() {
      if (!this.cart || !this.cart.country) return null;

      if (this.cart.country.is_delivery_available) {
        if (this.cart.is_delivery_included) {
          return this.$t("ARTWORK.SHIPPING_INCLUDED");
        }
        return `${this.$t("ARTWORK.ADDITIONAL_SHIPPING_COST")} ${
          this.cart.delivery.amount
        }`;
      } else {
        return `${this.$t("ARTWORK.ASK_ABOUT_SHIPPING")}`;
      }
      return null;
    }
  },

  methods: {
    addToCart() {
      this.$emit("onAddToCart");
      this.$cart.country = this.shippingCountry;
    },

    async onCountryChange(e) {
      if (!e) return;
      console.log("OnCountryChange", e);
      this.loading = true;
      this.cart = null;
      await handler.handle(async () => {
        const payload = {
          country_id: e.id,
          artworks: [this.artworkId],
          is_business: false
        };

        const res = await this.$axios.post(`/cart/details`, payload);
        this.cart = res.data["data"];
      });
      this.loading = false;
    }
  }
};
</script>

